export const INVALID_ATTACHMENT_SIZE_ERROR = `The max file size is 10Mb`;
export const INVALID_ATTACHMENT_NAME_LENGTH_ERROR = `The file name length exceeds 100 character limit`;
export const INVALID_ATTACHMENT_FORMAT_ERROR =
  'Invalid file format. Please upload a file in one of the following formats: JPG, PNG, PDF';
